// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fKyGPPmnoXXW0sy6vEUm{width:100%;margin-top:20px}.zFgJoBNq1cafR9LDwThd{gap:12px;width:100%;display:flex}.nGAPqC2Qdg8gTd2Rv0qv{width:100%;margin-bottom:8px}.nhii5OKAsaQ9mOXW6PNR{margin-bottom:8px;display:block}.CXXEPOChHXIaO0rGZ1jL{align-items:start;margin-bottom:32px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `fKyGPPmnoXXW0sy6vEUm`,
	"timeDropdownList": `zFgJoBNq1cafR9LDwThd`,
	"timeDropdown": `nGAPqC2Qdg8gTd2Rv0qv`,
	"label": `nhii5OKAsaQ9mOXW6PNR`,
	"checkbox": `CXXEPOChHXIaO0rGZ1jL`
};
export default ___CSS_LOADER_EXPORT___;
